import { Label } from '@britishcouncil/react-admin';
import styled from '@emotion/styled';
import { useMemo } from 'react';
import { SemanticCOLORS, SemanticSIZES } from 'semantic-ui-react';

type Props = { date: string; size?: SemanticSIZES; color?: SemanticCOLORS };

export const DayOfTheWeekBadge = ({ date, ...rest }: Props) => {
  const dayOfTheWeek = useMemo(() => {
    const [year, month, day] = date.split('T')[0].split('-').map(Number);
    const localDate = new Date(year, month - 1, day);
    if (!Number.isNaN(localDate.getTime())) {
      switch (localDate.getDay()) {
        case 0:
          return 'SUN';
        case 1:
          return 'MON';
        case 2:
          return 'TUE';
        case 3:
          return 'WED';
        case 4:
          return 'THU';
        case 5:
          return 'FRI';
        case 6:
          return 'SAT';
      }
    } else return 'Invalid';
  }, [date]);

  return (
    <S.Label color={dayOfTheWeek !== 'SAT' && dayOfTheWeek !== 'SUN' ? 'grey' : 'blue'} {...rest}>
      {dayOfTheWeek}
    </S.Label>
  );
};

const S = {
  Label: styled(Label)`
    &.ui.label {
      width: 40px;
      display: flex;
      justify-content: center;
    }
  `,
};
